import type { Topic } from "../services/datastore";

export function getTopicTypeName(topic: Topic) {
  return topic.typeName ?? topic.messageTypeName;
}
